import React, { useState } from "react";

// 5 avis Google Maps réels de la fiche Atelier AX (5,0★ · 9 avis).
// Contenu volontairement figé en dur : affichage visuel uniquement.
// SEO : le texte COMPLET de chaque avis reste dans le HTML prerendu
// (le repli 3 lignes est purement visuel, via line-clamp CSS).
// Aucun aggregateRating / Review en JSON-LD (avis auto-servis = ignorés
// ou pénalisables par Google). Le JSON-LD LocalBusiness propre est prévu en Phase 7.
const REVIEWS = [
    {
        name: "oussama elmontaser",
        when: "il y a 2 ans",
        text: "Excellent magasin ! Large sélection de produits de qualité à des prix compétitifs. Le personnel était très serviable et compétent, m'aidant à trouver exactement ce dont j'avais besoin. Je recommande à 100% ce magasin à tous ceux qui recherchent des produits de qualité à des prix très abordables",
    },
    {
        name: "Amal Bouzbouz",
        when: "il y a 2 ans",
        text: "Cela fait 6 mois que j'ai pris un chargeur USB C et il fonctionne toujours parfaitement. Je recommande fortement les produits Atelier AX. Courage les gars.",
    },
    {
        name: "Saad El Khayat",
        badge: "Local Guide",
        when: "il y a 2 ans",
        text: "Accessoires de haute qualité à prix raisonnables. Je les recommande vivement.",
    },
    {
        name: "Soufiane Kemal Ben",
        when: "il y a un an",
        text: "J'ai eu une excellente expérience dans cette boutique de téléphonie ! Le personnel était très aimable, compétent et patient. Le service était rapide. Je recommande vivement cet endroit si vous recherchez des produits de qualité et un excellent service client !",
    },
    {
        name: "Akram Kadri",
        when: "il y a 2 ans",
        text: "Service de qualité 👌🏻 je recommande",
    },
];

const GOOGLE_MAPS_URL =
    "https://www.google.com/maps/place/Atelier+AX./@34.0211877,-5.0171569,17z/data=!4m8!3m7!1s0xd9f8b2f53153b79:0xdf792ba316fb2d87!8m2!3d34.0211877!4d-5.014582!9m1!1b1!16s%2Fg%2F11y1zv9kwl";

// Repli visuel à 3 lignes (line-clamp) : le texte complet reste dans le DOM.
const CLAMP_CLASSES =
    "[display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:3] overflow-hidden";

// Logo « G » Google officiel (4 couleurs).
const GoogleLogo = ({ className = "w-6 h-6" }) => (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
        <path
            fill="#4285F4"
            d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"
        />
        <path
            fill="#34A853"
            d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z"
        />
        <path
            fill="#FBBC05"
            d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z"
        />
        <path
            fill="#EA4335"
            d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"
        />
    </svg>
);

const Star = () => (
    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5 fill-[#d4af37]" aria-hidden="true">
        <path d="M12 2l2.94 6.36 6.96.84-5.16 4.79 1.38 6.87L12 17.6l-6.12 3.26 1.38-6.87L2.1 9.2l6.96-.84L12 2z" />
    </svg>
);

const Stars = () => (
    <div className="flex items-center gap-0.5" aria-label="5 étoiles sur 5">
        {[...Array(5)].map((_, i) => (
            <Star key={i} />
        ))}
    </div>
);

const ReviewCard = ({ review }) => {
    const [expanded, setExpanded] = useState(false);
    return (
        <article className="min-w-[250px] sm:min-w-[270px] lg:min-w-0 snap-start rounded-2xl bg-white border border-black/[0.06] shadow-[0_4px_18px_rgba(0,0,0,0.06)] p-4 flex flex-col gap-2.5 transition-shadow duration-300 hover:shadow-[0_10px_28px_rgba(0,0,0,0.1)]">
            <div className="flex items-center justify-between gap-2">
                <Stars />
                <span className="inline-flex items-center gap-1 rounded-full bg-[#F5F5F7] border border-black/[0.05] px-2 py-0.5 text-[10px] font-medium text-neutral-500">
                    <GoogleLogo className="w-3 h-3" />
                    Avis Google
                </span>
            </div>
            <div>
                <p
                    className={`text-[12.5px] leading-relaxed text-neutral-700 ${
                        expanded ? "" : CLAMP_CLASSES
                    }`}
                >
                    «&nbsp;{review.text}&nbsp;»
                </p>
                <button
                    type="button"
                    onClick={() => setExpanded((v) => !v)}
                    aria-expanded={expanded}
                    className="mt-1 text-[11.5px] font-semibold text-neutral-800 underline underline-offset-2 decoration-black/20 hover:text-[#d4af37] hover:decoration-[#d4af37]/50 transition-colors"
                >
                    {expanded ? "Réduire" : "Lire la suite"}
                </button>
            </div>
            <div className="mt-auto flex items-baseline justify-between gap-2 pt-2 border-t border-black/[0.05]">
                <span className="text-[12.5px] font-semibold text-[#1C1C1E]">
                    {review.name}
                    {review.badge && (
                        <span className="ml-1.5 text-[10px] font-medium text-[#d4af37]">
                            · {review.badge}
                        </span>
                    )}
                </span>
                <span className="text-[11px] text-neutral-400 whitespace-nowrap">{review.when}</span>
            </div>
        </article>
    );
};

const GoogleReviews = () => {
    return (
        <div className="mt-10 md:mt-12 text-left">
            {/* En-tête : note Google globale */}
            <div className="flex flex-col items-center text-center">
                <div className="inline-flex items-center gap-2.5 rounded-full bg-white border border-black/[0.06] shadow-[0_2px_10px_rgba(0,0,0,0.05)] px-4 py-2">
                    <GoogleLogo className="w-5 h-5" />
                    <span className="font-display text-[15px] font-semibold text-[#1C1C1E]">5,0</span>
                    <Stars />
                    <span className="text-[13px] text-neutral-500">· 9 avis Google</span>
                </div>
                <p className="mt-3 text-[13px] md:text-[14px] text-neutral-500">
                    Ce que nos clients disent de nous sur Google
                </p>
            </div>

            {/* Desktop : 5 cartes sur une seule ligne (grid 5 colonnes égales).
                Mobile/tablette : scroll horizontal avec snap. */}
            <div className="mt-6 flex gap-3 sm:gap-4 overflow-x-auto snap-x snap-mandatory pb-2 no-scrollbar lg:grid lg:grid-cols-5 lg:overflow-visible lg:pb-0">
                {REVIEWS.map((r) => (
                    <ReviewCard key={r.name} review={r} />
                ))}
            </div>

            <div className="mt-6 text-center">
                <a
                    href={GOOGLE_MAPS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-[13px] font-semibold text-neutral-800 underline underline-offset-4 decoration-black/20 hover:text-[#d4af37] hover:decoration-[#d4af37]/50 transition-colors"
                >
                    Voir tous les avis sur Google
                    <svg viewBox="0 0 24 24" className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M7 17L17 7M9 7h8v8" />
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default GoogleReviews;
